
import Vue from 'vue';
import { common } from '@tencent/ceiba-base-components';
let gShareData = {};
let gImageShareData = {};
const isApp = () => /com\.tencent\.gamecommunity/.test(window.navigator.userAgent);

export default {
  /**
     * 初始化APP环境的分享功能
     */
  setAPPShare: async (params) => {
    gShareData.title = params?.title;
    gShareData.summary = params?.desc || params?.summary;
    gShareData.targetUrl = params?.link || params?.targetUrl;
    gShareData.thumbUrl = params?.icon || params?.thumbUrl;
    gShareData.callback = params?.callback;
    console.log('[shanxian-ast] setAPPShare params=', params);
    console.log('[shanxian-ast] setAPPShare gShareData=', gShareData);
  },
  goAPPShare: async () => new Promise(((resolve) => {
    window.SX_WEB?.jsBridge.share.showShareDialog(gShareData).then((res) => {
      console.log('spark app share res:', res);
      const type = typeof gShareData?.callback;
      if (type !== 'undefined' && type === 'function') {
        gShareData.callback(res);
      }
      resolve(res);
    });
  })),
  /**
     * 图片分享
     */
  setImageShare: async (params) => {
    gImageShareData = params;
    console.log('shanxian imageShare params=', params);
  },
  imageShare: async () => new Promise(((resolve) => {
    window.SX_WEB?.jsBridge.share.showShareDialogV2(gImageShareData).then((res) => {
      resolve(res);
    });
  })),
  isAPP: () => {
    console.log('shanxian isAPP');
    return isApp();
  },
  gotoAPP: async (path, params = { ch: '' }) => {
    console.log('launchApp Vue.prototype.$actInfo', Vue.prototype.$actInfo);
    console.log('gotoApp');
    // console.log('launchApp IosisApp()', isApp());
    if (!isApp()) {
      const link = path ? path : window.location.href;
      const ch = params.ch ? params.ch : common.tool.getQueryparams('ch');
      const actInfo = Vue.prototype.$actInfo;
      // console.log('launchApp Ios res', actInfo.page_id);
      const pageId = actInfo.page_id;
      const { reportPv = '' } = actInfo.config.configs[pageId].canvasConfig;
      console.log('launchApp reportPv', reportPv);
      const reportSz = reportPv.split('|');
      const reportGs = reportSz.length;
      console.log('launchApp reportGs', reportGs);
      const prevIda = '';
      if (reportGs === 3) {
        // console.log('launchApp reportSz[2]', reportSz[2]);
        const prevIda  = reportSz[2];
        console.log('launchApp prevIda', prevIda);
      }
      // const [sxContentid = '', sxContentname = '', prev_Id = ''] = reportPv.split('|');
      // if (prev_Id === '') {
      //   prev_Id = '';
      // }
      // prev_Id = prev_id ? prev_id : '';
      window.SX_WEB?.app.launch({
        href: link,
        autoInstall: true,
        prevId: prevIda,
        downloadUrlParams: {
          shanxianinchannel: ch,
          sxaction: 'download',
          // prev_id: prev_Id,
        },
      });
    } else {
      console.log('app 内');
      window.SX_WEB?.jsBridge.ui.openView({ options: path });
    }
  },
  openView: async (params) => {
    window.SX_WEB?.jsBridge.ui.openView({ options: params.url });
  },
  /**
     * 去登录操作
     * @param {type} help:助力 team:组队
     * @param {ch} 渠道号
     * @param {url} 链接
     */
  getShareUrl: async (params = { userInfo: {}, type: 'help', url: '' }) => {
    console.log('share params', params);
    const avatar = params.userInfo.avatarUrl ? params.userInfo.avatarUrl : '';
    let nickName = params.userInfo.nickname || params.userInfo.nickName;
    nickName = nickName ? nickName : '闪现用户';
    const uid = common.tool.getCookie('uid');

    const url = params.url ? params.url : `${window.location.origin + window.location.pathname}?c_page=1`;
    const shareUrl = common.tool.setUrlParams({
      avatar,
      nickName,
      inviter: params.userInfo.openid,
      uid,
      // ch: params.ch,
      type: params.type,
    }, url);
    return shareUrl;
  },
  // app外拉起内置页面用scheme
  openScheme: async (url, params = { ch: '' }) => {
    const ch = params.ch ? params.ch : common.tool.getQueryparams('ch');
    console.log('openscheme');
    window.SX_WEB?.app.launch({
      scheme: url,
      autoInstall: true,
      downloadUrlParams: {
        shanxianinchannel: ch,
        sxaction: 'download',
      },
    });
  },
};
